import { WorkflowElement } from "../element"

export class Empty extends WorkflowElement {
  static get elementName() {
    return "workflow-empty"
  }

  initialize() {
    this.click = this.click.bind(this)
  }

  connectedCallback() {
    this.addEventListener("click", this.click)
    this.openEvent = new CustomEvent("va-popover:open", {
      detail: {
        anchor: this,
        isEntryNode: true,
        isStandalone: true
      }
    })
    this.boundPopoverClosed = this.popoverClosed.bind(this)
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.click)
    Workflow.removeEventListener("va-popover:close", this.boundPopoverClosed)
  }

  popoverClosed() {
    this.classList.remove("opacity-0")
  }

  click(event) {
    if (event.target.closest("workflow-start")) {
      Workflow.dispatchEvent(this.openEvent)
      Workflow.addEventListener("va-popover:close", this.boundPopoverClosed)
      this.classList.add("opacity-0")
    }
  }

  compute() {
    // noop
  }
}

customElements.get("workflow-empty") ||
  customElements.define("workflow-empty", Empty)
